import React from 'react';
import Loader from './loader';

class PropertyFavoriteButton extends React.Component{
    constructor(props)
    {
        super(props);
        this.onFavoriteClicked = this.onFavoriteClicked.bind(this);
    }
    
    onFavoriteClicked(){
        if(this.props.onFavoriteClicked){
            this.props.onFavoriteClicked(!this.props.isFavorite);
        }
    }

    /* componentWillReceiveProps(nextProps){
        if(this.props.pageUpdatedOn !== undefined && this.props.pageUpdatedOn !== null &&
            nextProps.pageUpdatedOn !== undefined && nextProps.pageUpdatedOn !== null &&            
            JSON.stringify(this.props.pageUpdatedOn) !== JSON.stringify(nextProps.pageUpdatedOn))
        {
            if(this.state && this.state.FavoriteList && this.state.FavoriteList.Listings)
            {
                var tmpProperty = this.state.FavoriteList.Listings.find(o => o.Id === this.props.property.Id);
                if(tmpProperty !== undefined && tmpProperty !== null)
                {
                    this.setState({isFavorite: tmpProperty.IF});
                }                   
            }
            else
            {
                this.setState({isFavorite: 
                    (nextProps.property && nextProps.property.IF) ? nextProps.property.IF : false});
            }
        }
    } */

    render(){
        var bButton = null;
        
        if(this.props.fromPropertyDetail){

            if(this.props.isIFProcessing){
                bButton = (
                    <span className="input-group-addon js-close-input-search" style={{float: "left", padding: "0 0 0 7px", background: "transparent", verticalAlign: "middle"}}>
                        <Loader inline="true" width="25" height="25" />
                    </span>
                );
            }
            else{
                bButton = (
                    <div className="div_icon tour-fav-bookmark">
                        <div className={this.props.isFavorite ? 'active' : ''}  title={this.props.isFavorite ? 'Home is saved' : 'Save this Home'} onClick={this.onFavoriteClicked}>
                            <i className="fa icon-tru-heart"></i>
                        </div>
                    </div>
                );
            }
        }
        else{
            if(this.props.isIFProcessing){
                bButton = (
                    <span className="input-group-addon js-close-input-search" style={{float: "left", padding: "0 0 0 7px", background: "transparent", verticalAlign: "middle"}}>
                        <Loader inline="true" width="18" height="18" />
                    </span>
                );
            }
            else{
                bButton = (
                    <div className={this.props.isFavorite ? 'heart_icon active' : 'heart_icon'} title={this.props.isFavorite ? 'Home is saved' : 'Save this Home'} onClick={this.onFavoriteClicked}>
                        <i className="fa icon-tru-heart"></i>
                    </div>
                );
            }
        }

        return(
            <div style={{display: "inline-block", verticalAlign: "middle"}}>
                {bButton}
            </div>
        );
    }
}

export default PropertyFavoriteButton;